const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  return (
    <div className="pagination">
      <button className="blue-btn" disabled={currentPage === 1} onClick={() => onPageChange(currentPage - 1)}>
        Poprzednia
      </button>
      <span>Strona {currentPage} z {totalPages == 200 ? ("200+") : totalPages}</span>
      <button className="blue-btn" disabled={currentPage >= totalPages} onClick={() => onPageChange(currentPage + 1)}>
        Następna
      </button>
    </div>
  );
};

export default Pagination;
